"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
/* especially meant for usecases where the page container has a max width,
/* but we need its bottom border to stretch the full width of the screen */
/* props can be any valid color value,
/* can be borderBottom/Top/Left/Right * can be style, className & children */
/**
 * @component Renders a section component with customizable border properties.
 *
 * - The props object containing the following properties:
 * @prop {boolean} props.borderTop: A boolean indicating whether to display a top border. Defaults to false.
 * @prop {boolean} props.borderRight: A boolean indicating whether to display a right border. Defaults to false.
 * @prop {boolean} props.borderLeft: A boolean indicating whether to display a left border. Defaults to false.
 * @prop {boolean} props.borderBottom: A boolean indicating whether to display a bottom border. Defaults to false.
 * @prop {React.CSSProperties} props.style: Additional CSS styles to apply to the section.
 * @prop {React.ReactNode} props.children: The content to be rendered inside the section element.
 * @return {ReactElement} The rendered section component.
 */
var Section = function (props) {
    return (react_1.default.createElement(styled_1.StyledSection, __assign({}, props), props.children));
};
exports.Section = Section;
